import request from '@/utils/request'

// 查询公告分页
export function pageNotice(data) {
  return request({
    url: '/homeservice/notice/page',
    method: 'post',
    data: data
  })
}

// 查询公告列表
export function listNotice(query) {
  return request({
    url: '/homeservice/notice/list',
    method: 'get',
    params: query
  })
}

// 查询公告详情
export function getNotice(data) {
  return request({
    url: '/homeservice/notice/detail',
    method: 'get',
    params: data
  })
}

// 新增公告
export function addNotice(data) {
  return request({
    url: '/homeservice/notice/add',
    method: 'post',
    data: data
  })
}

// 修改公告
export function updateNotice(data) {
  return request({
    url: '/homeservice/notice/edit',
    method: 'post',
    data: data
  })
}

// 删除公告
export function delNotice(data) {
  return request({
    url: '/homeservice/notice/delete',
    method: 'post',
    data: data
  })
}
